"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function TheBigPicture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const metrics = [{
    headline: "5 Days",
    meta: "Weekly Learning"
  }, {
    headline: "100%",
    meta: "Creative Growth"
  }, {
    headline: "Our Team",
    meta: "Dedicated Teachers"
  }];
  return <section data-section-id="276" id="the-big-picture" className="bg-background text-foreground relative overflow-hidden min-h-[70vh] flex items-center">
      {}
      <div aria-hidden="true" className="absolute inset-y-0 right-0 w-full md:w-2/5 opacity-30 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_learning_scene.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_learning_scene.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_learning_scene.png-wvc-sizes" alt="" loading="lazy" decoding="async" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/60 to-transparent md:via-background/30" />
      </div>

      {}
      <div aria-hidden="true" className="absolute -top-24 -left-24 w-[28rem] h-[28rem] rounded-lg bg-primary/5 blur-3xl pointer-events-none" />

      <div ref={ref} className={`relative z-10 w-full max-w-7xl mx-auto px-[8%] py-20 md:py-28 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="max-w-[900px]">
          {}
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-10 bg-primary" />
            <p className="font-default text-xs tracking-[0.3em] uppercase" style={{
            color: "var(--chart-1)"
          }}>
              Class 2A
            </p>
          </div>

          {}
          <h1 className="font-default font-bold text-foreground text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight mb-8">
            Where curiosity{" "}
            <em className="italic font-normal" style={{
            color: "var(--chart-1)"
          }}>
              blooms daily
            </em>{" "}
            in our classroom
          </h1>

          {}
          <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mb-12">
            Welcome to Class 2A, a vibrant space for young minds to explore, create, and grow together every single day.
          </p>

          {}
          <div className="flex flex-col sm:flex-row sm:items-stretch gap-6 sm:gap-0 mb-12">
            {metrics.map((metric, i) => <div data-index={i} key={i} className="flex items-center flex-1">
                {i > 0 && <Separator orientation="vertical" className="hidden sm:block mx-6 lg:mx-8 !h-16 bg-border/60" />}
                <div className="flex flex-col">
                  <span className="font-default font-bold text-3xl md:text-4xl leading-tight" style={{
                color: "var(--chart-1)"
              }}>
                    {metric.headline}
                  </span>
                  <span className="font-default text-[11px] tracking-[0.25em] uppercase text-muted-foreground mt-2">
                    {metric.meta}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <Link to="/ParentToolboxPage">
            <Button size="lg" className="rounded-lg px-8 h-12 font-default tracking-wide bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
              Download Permission Slip
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}